export default __webpack_public_path__ + "static/media/DadCanYouDoThis_04.0107ea77.png";